import { NavLink } from "react-router-dom";
import "./styles/MenuItem.scss";
import { MenuItems } from "@src/types/global";

interface IProps {
    item: MenuItems;
}

const MenuItem = ({ item }: IProps) => {
    return (
        <NavLink
            className={({ isActive }) =>
                `menu__items__item ${isActive ? "active" : null}`
            }
            title={`Navigate to ${item.title}`}
            to={item.url}
            tabIndex={2}
        >
            {item.icon}
            <p>{item.title}</p>
        </NavLink>
    );
};
export default MenuItem;
